import Modal from "react-bootstrap/Modal";
import logoutsvg from "../../../assets/images/logout.svg";

function LogoutModal({ show, handleClose, handleConfirm }) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="modal-common delete-pop"
    >
      <Modal.Body>
        <div className="text-center">
          {/* <div className="garbage-box d-flex justify-content-center align-items-center">
            <img alt="" src={logoutsvg} />
          </div> */}
          <h2 className="mb-3">Logout Account</h2>
          <p>Are you sure you want to logout ?</p>
          <div className="d-flex flex-wrap gap-2 mt-4 justify-content-center">
            <button onClick={handleClose} className="btn blue-btn">
              No
            </button>
            <button onClick={handleConfirm} className="btn gray-btn">
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LogoutModal;
